import clsx from 'clsx'
import { useMemo } from 'preact/hooks'

export function ResultsSwatches({ result, swatches, onSelectSwatch }) {
  if (!swatches || swatches.length === 0) return null

  return (
    <>
      <div className="flex gap-1">
        {swatches.map((swatch) => (
          <Swatch
            key={swatch.handle}
            swatch={swatch}
            onSelectSwatch={onSelectSwatch}
            isCurrentSwatch={swatch.handle === result.handle}
          />
        ))}
      </div>
    </>
  )
}

function Swatch({ swatch, onSelectSwatch, isCurrentSwatch }) {
  function handleClick() {
    onSelectSwatch(swatch.handle)
  }

  const color = useMemo(() => {
    const tag = swatch?.tags?.find((tag) => tag.includes('Hex'))
    if (!tag) return '#a5a5a5'

    return tag.split('-').pop()
  }, [swatch])

  return (
    <button
      data-dl-track="toggle_variant"
      data-dl-product-id={swatch.productLegacyResourceId}
      data-dl-variant-id={swatch.productLegacyResourceId}
      data-dl-attribute="item_colour"
      data-dl-value={swatch.colourName}
      style={{ '--bg-custom': color }}
      className={clsx('size-6 rounded-full overflow-hidden bg-[--bg-custom] border outline-offset-0 outline-1', isCurrentSwatch ? 'border-white border-2 outline outline-black' : 'border-neutral-secondary')}
      onClick={handleClick}
    />
  )
}
